import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = authService.getCurrentUser();
  const isAuthenticated = authService.isAuthenticated();

  // Hide navbar on login, register, verify-email, employee home, detail pages, settings, and edit-profile
  if (location.pathname === '/login' ||
      location.pathname === '/register' ||
      location.pathname === '/verify-email' ||
      location.pathname === '/employee/home' ||
      location.pathname === '/employee/settings' ||
      location.pathname === '/employee/edit-profile' ||
      location.pathname.startsWith('/employee/vacancies/')) {
    return null;
  }

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  return ;
};

export default Navbar;

